import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { BzgToastRef } from 'bz-genome-angular/toast/toast.ref';
import { BzgToastService } from 'bz-genome-angular';

@Injectable()
export class AuthenticationTypeValidationSevice {
    private isAuthenticationValidUrl = 'api/Authentication/IsValid';

    private _toastRef: BzgToastRef = null;
    private _toastActionText = '';
    private _toastSubscription: Subscription;

    constructor(private _restApi: RestApi,
        private _toastService: BzgToastService,
        private _translateService: TranslateService,
        private _router: Router) {
    }

    public validate(response: boolean) {
        if(!response && !this._toastRef) {
            this.showMessage();
        } else if(response && this._toastRef) {
            const toastIndex = this._toastService.toastListRefs['top'].toastList.findIndex(toast => toast.action === this._toastActionText);
            if(toastIndex !== -1) {
                this._toastService.toastListRefs['top'].removeFromList(toastIndex);
            }
            this._toastRef = null;
            this._unsubscribe();
        }
    }

    public forceToCloseToast() {
        if(this._toastRef) {
            const toastIndex = this._toastService.toastListRefs['top'].toastList.findIndex(toast => toast.action === this._toastActionText);
            if(toastIndex !== -1) {
                this._toastService.toastListRefs['top'].removeFromList(toastIndex);
            }
            this._toastRef = null;

        }
    }

    private _goToAuthentication() {
        this._router.navigate(['mc', 'Security']);
        this.showMessage();
    }

    private showMessage() {
        this._translateService.get('AUTHENTICATION.INVALID_AUTHENTICATION_TYPE').subscribe((message: string) => {
            this._translateService.get('AUTHENTICATION.GO_TO_SECURITY').subscribe((actionText: string) => {
                this._toastRef = this._toastService.open(
                    message,
                    {
                        fullwidth: true,
                        hideCloseIcon: true,
                        type: 'warning',
                        verticalPosition: 'top',
                        customClass: 'bmc-maintenance-window',
                        action: actionText
                    });
                this._toastSubscription = this._toastRef.onAction().subscribe(() => this._goToAuthentication());
                this._unsubscribe();
                this._toastActionText = actionText;
            });
        });
    }

    private _unsubscribe() {
        if(this._toastSubscription) {
            this._toastSubscription.unsubscribe();
        }
    }
}
